/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * Disable Zone.js patching of passive event listeners to improve performance
 * This prevents Zone.js from interfering with our passive event listener setup
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__zone_symbol__PASSIVE_EVENTS = ["scroll", "wheel", "touchstart", "touchmove", "touchend", "touchcancel"];
